import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import './PortofolioItemComponent.css';
import portofolioImage from "../../../../assets/images/project/interior/MAF_SD/interior-maf-sd-thumb.jpg";

function Portofolio08() {

    const navigate = useNavigate();
    const navigateHome = () => {
        navigate('/detail-project/portofolio-maf-sd-house');
    };

    return (
        <div className='portofolio-rumah-01' id='id-portofolio-01'>
            <div className="portofolio-rumah-01-container">
                <div className='portofolio-rumah-01-container-img'>
                    <img src={portofolioImage} alt="imgFoto" className="portofolio-rumah-01-image" />
                </div>

                <div className="portofolio-rumah-01-overlay" onClick={navigateHome}>
                    <h1>MAF SD</h1>
                    <p>Bogor, Jawa Barat</p>
                </div>
            </div>
        </div>
    );
}

export default Portofolio08;